/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.26.0
 * @since 1.24.0
 */

import { ReactElement } from 'react';

import isFunction from 'lodash/isFunction';

import { LinkBlock } from '@/main/components/common';
import { openExternalRoute } from '@/main/routes/constants/externalRoutes';
import { ROUTE_NEWS_ID, RoutePath } from '@/main/routes/constants/routesConstants';

import { IUserNotificationTranslation } from '../../internationalization/types';
import { INotificationsEntity } from '../types';
import { getNotificationContent } from './commonNotificationsUtils';
import { getIsExternalNotification } from './notificationsUtils';

export const getNewsNotificationData = (
    entity: INotificationsEntity,
    translation: IUserNotificationTranslation,
    handleExternalNotification: (id: string | number) => void,
    onLinkClick?: () => void,
): [string, ReactElement] => {
    const content = getNotificationContent(entity);

    const isExternalLink = getIsExternalNotification(entity);
    const linkHref = isExternalLink ? entity.link : RoutePath.newsId.replace(ROUTE_NEWS_ID, String(entity.id) || '');

    const handleLinkClick = () => {
        if (isExternalLink && linkHref && entity.id) {
            handleExternalNotification(entity.id);
            openExternalRoute(linkHref, '_blank');
        }
        if (isFunction(onLinkClick)) onLinkClick();
    };
    const ItemLink = (
        <div>
            <LinkBlock
                withArrow
                isExternalUrl={isExternalLink}
                target={isExternalLink ? '_blank' : '_self'}
                url={linkHref}
                onClick={handleLinkClick}
            >
                {translation.linkText.news}
            </LinkBlock>
        </div>
    );
    return [content, ItemLink];
};
